import script from "./testBnner.vue?vue&type=script&setup=true&lang=js"
export * from "./testBnner.vue?vue&type=script&setup=true&lang=js"

import "./testBnner.vue?vue&type=style&index=0&id=de95bbf0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de95bbf0"]])

export default __exports__